import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';

import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import OAuthCallback from './pages/OAuthCallback';
import AssetDetail from './pages/AssetDetail';
import SellerProfile from './pages/SellerProfile';
import DashboardLayout from './pages/dashboard/DashboardLayout';
import Overview from './pages/dashboard/Overview';
import MyAssets from './pages/dashboard/MyAssets';
import MySales from './pages/dashboard/MySales';
import MyPurchases from './pages/dashboard/MyPurchases';
import DataRequests from './pages/dashboard/DataRequests';
import Subscriptions from './pages/dashboard/Subscriptions';
import UploadAsset from './pages/dashboard/UploadAsset';
import EditAsset from './pages/dashboard/EditAsset';
import Settings from './pages/dashboard/Settings';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/oauth/callback" element={<OAuthCallback />} />
      <Route path="/asset/:id" element={<AssetDetail />} />
      <Route path="/seller/:id" element={<SellerProfile />} />

      <Route path="/dashboard" element={
        <ProtectedRoute>
          <DashboardLayout />
        </ProtectedRoute>
      }>
        <Route index element={<Overview />} />
        <Route path="assets" element={<MyAssets />} />
        <Route path="sales" element={<MySales />} />
        <Route path="purchases" element={<MyPurchases />} />
        <Route path="requests" element={<DataRequests />} />
        <Route path="subscriptions" element={<Subscriptions />} />
        <Route path="upload" element={<UploadAsset />} />
        <Route path="assets/:id/edit" element={<EditAsset />} />
        <Route path="settings" element={<Settings />} />
      </Route>

      {/* Legacy redirects */}
      <Route path="/signin" element={<Navigate to="/login" replace />} />
      <Route path="/signup" element={<Navigate to="/register" replace />} />
      <Route path="/market" element={<Navigate to="/" replace />} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
